module.exports = __webpack_public_path__ + "img/chatbot2.69cbe5e0.svg";